//============================================================================
// Name        : ReceiveStatus.tsx
// Purpose     : Receive Status component
// Created     : 2019-06-25
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line:no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";
import {IReceiveStatusProps, ReceiveStatuses} from "./types";

class ReceiveStatus extends React.Component<IReceiveStatusProps, {}> {
    getAddedClass = () => {
        if (this.props.addedClass) {
            return this.props.addedClass;
        } else {
            return String;
        }
    }
    renderStatus = () => {
        switch (this.props.status) {
            case ReceiveStatuses.Pending:
                return <span className="label label-danger">PENDING</span>;
            case ReceiveStatuses.InProgress:
                return <span className="label label-warning">IN-PROGRESS</span>;
            case ReceiveStatuses.Complete:
                return <span className="label label-success">COMPLETED</span>;
        }
    }

    render() {
        return (
            <div className={this.props.addedClass}>
                {this.renderStatus()}
            </div>
        );
    }
}

export default ReceiveStatus;
